import React, { useMemo, useEffect, useRef } from 'react';
import { useFocused, useReadOnly } from 'slate-react';
import schemify from 'url-schemify';
import { withTranslation } from 'react-i18next';

import { validateUrl } from '../../utils/validators';

import DocNodeWithChooser from '../doc-node-with-chooser';
import EmbedPane from 'components/EmbedPane';

const DocEmbed = ({ attributes, children, element, url, menuItems, isPublic, onNodeChange, onRemove, t }) => {
    const readOnly = useReadOnly();

    const handleMenuAction = type => {
        onNodeChange && onNodeChange(element, type);
    }

    const handleUrlChange = url => {
        onNodeChange && onNodeChange(element, element.type, { url });
    }

    const handleRemoveClick = () => {
        onRemove(element);
    }

    const isFocused = useFocused();

    return (
        <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={menuItems} depth={1} onAction={handleMenuAction}>
            <div className={'doc-node doc-media' + (isFocused ? ' focused' : '')} {...attributes} contentEditable={false} style={{ userSelect: 'none' }}>
                <EmbedPane url={url} onChange={!readOnly && handleUrlChange} expandDisabled={isPublic} onRemove={!readOnly && handleRemoveClick} />
            </div>
        </DocNodeWithChooser>
    )
}

export default withTranslation(['doc', 'common'])(DocEmbed);
